import React, { FC, useState } from 'react';
import { EventDTO } from '@atlassiansox/phobos-client-ts';
import { some } from 'lodash';

// eslint-disable-next-line max-len
import ErrorBudgetGraph from '@/components/composed/new-slo-views/expanded/graph/error-budget-graph';
import {
  mapToDataPointEventTotals,
  populateDailyDataTotals,
} from '@/components/composed/new-slo-views/common/utils';
import { SLOGraph } from '@/controllers';
import GraphTabs, {
  GraphEventSource,
} from '@/components/composed/new-slo-views/expanded/graph/graph-tabs';

import FaultZone from './fault-zone';
import { GraphState } from './types';

const LargeGraph: FC<SLOGraph & { onEdit: () => void }> = ({
  error,
  warnings,
  errorBudgetDomain,
  dataPoints,
  errorBudgetDataPoints,
  onEdit,
  publicId,
  isResponsive,
  performance,
  events,
}) => {
  const [graphState, setToggleState] = useState<GraphState>(GraphState.ShowErrorBudgetGraph);
  const [graphEventSource, setGraphEventSource] = useState<GraphEventSource>(
    GraphEventSource.Active
  );
  const hasEventsFromHistoricalIndicators = events
    ? some(events, (event: EventDTO) => event.isFromHistoricalIndicator)
    : false;
  const hasWarnings = warnings.length > 0;

  if (error && !hasWarnings) {
    return (
      <FaultZone
        performance={performance}
        error={error}
        warnings={warnings}
        onSloEdit={onEdit}
        publicId={publicId!}
      />
    );
  }

  return (
    <>
      {hasWarnings && (
        <GraphTabs
          setToggleState={setToggleState}
          graphState={graphState}
          onToggleHistoricalIndicators={(value: string[]) => {
            setGraphEventSource(value[0] as GraphEventSource);
          }}
          graphEventSource={graphEventSource}
          hasWarnings={hasWarnings}
          hasEventsFromHistoricalIndicators={hasEventsFromHistoricalIndicators}
        />
      )}

      {graphState === GraphState.ShowWarnings ? (
        error &&
        hasWarnings && (
          <FaultZone
            performance={performance}
            error={error}
            warnings={warnings}
            onSloEdit={onEdit}
            publicId={publicId!}
          />
        )
      ) : (
        <ErrorBudgetGraph
          data={mapToDataPointEventTotals(dataPoints)}
          errorBudgetData={populateDailyDataTotals(errorBudgetDataPoints, dataPoints)}
          errorBudgetDataDomain={errorBudgetDomain}
          showClickPrompt={false}
          preview
          isResponsive={isResponsive}
          graphEventSource={graphEventSource}
        />
      )}
    </>
  );
};

export default React.memo(LargeGraph);
